import { ArticleMeta, SiteArticle } from "./articles/types";
import RAG from "./articles/rag.meta";
import VULKAN_COMPUTE_PIPELINES from "./articles/vulkan-compute-pipelines.meta";
import KUBERNETES_MONOLITH_SCALING from "./articles/kubernetes-monolith-scaling.meta";
import NETWORK_SECURITY_FOUNDATIONS from "./articles/network-security-foundations.meta";
import PLATFORM_MODERNIZATION_PROGRAM from "./articles/platform-modernization-program.meta";
import MODULAR_HARDWARE from "./articles/reliability-observability-foundation.meta";
import DISCREET_ENGINE from "./articles/secure-delivery-pipeline.meta";
import DATA_PLATFORM_SCALEUP from "./articles/data-platform-scaleup.meta";

export * from "./articles/types";

export const BRIEFING_ARTICLES: ArticleMeta[] = [
    RAG,
    VULKAN_COMPUTE_PIPELINES,
    KUBERNETES_MONOLITH_SCALING,
    NETWORK_SECURITY_FOUNDATIONS,
];

export const PORTFOLIO_ARTICLES: ArticleMeta[] = [
    PLATFORM_MODERNIZATION_PROGRAM,
    MODULAR_HARDWARE,
    DISCREET_ENGINE,
    DATA_PLATFORM_SCALEUP,
];

const ARTICLES: ArticleMeta[] = [
    ...BRIEFING_ARTICLES,
    ...PORTFOLIO_ARTICLES,
];

export const ARTICLE_BY_SLUG: Record<string, ArticleMeta> = ARTICLES.reduce<Record<string, ArticleMeta>>((acc, article) => {
    acc[article.slug] = article;
    return acc;
}, {});

// Bodies are loaded per article, so the home page ships only the metadata its lists show.
const ARTICLE_BODIES: Record<string, () => Promise<{ default: SiteArticle }>> = {
    [RAG.slug]: () => import("./articles/rag"),
    [VULKAN_COMPUTE_PIPELINES.slug]: () => import("./articles/vulkan-compute-pipelines"),
    [KUBERNETES_MONOLITH_SCALING.slug]: () => import("./articles/kubernetes-monolith-scaling"),
    [NETWORK_SECURITY_FOUNDATIONS.slug]: () => import("./articles/network-security-foundations"),
    [PLATFORM_MODERNIZATION_PROGRAM.slug]: () => import("./articles/platform-modernization-program"),
    [MODULAR_HARDWARE.slug]: () => import("./articles/reliability-observability-foundation"),
    [DISCREET_ENGINE.slug]: () => import("./articles/secure-delivery-pipeline"),
    [DATA_PLATFORM_SCALEUP.slug]: () => import("./articles/data-platform-scaleup"),
};

export const loadArticle = (slug: string): Promise<SiteArticle> => ARTICLE_BODIES[slug]().then((module) => module.default);

export default ARTICLES;
